<template>
    <button class="btn" 
            :style="{ backgroundColor: color }" 
            @click.stop="handleClick">
      <i v-if="left_icon" :class="left_icon"></i>
      {{ text?text:'' }}
      <i v-if="right_icon" :class="right_icon" @click.stop="handleRightIconClick"></i>
    </button>
  </template>
  
  <script>
  export default {
    name: 'AppButton',
    props: {
      text: {
        type: String,
        
      },
      color: {
        type: String,
        default: 'transparent'
      },
      emitType: {
        type: String,
        required: true
      },
      left_icon: {
        type: String,
        default: null
      },
      right_icon: {
        type: String,
        default: null
      },
      width: {
        type: Number,
        default: 106 // default width in pixels
      },
      height: {
        type: Number,
        default: 42 // default height in pixels
      }
    },
    emits:['create','select', 'update','delete', 'back', 'close','list' ],
    methods: {
      handleClick() {
        this.emitEvent();
      },
      handleRightIconClick() {
        console.log("right icon clicked");
        this.$emit('close');
      },
      emitEvent() {
        switch (this.emitType) {
          case 'create':
            this.$emit('create');
            break;
          case 'select':
            this.$emit('select');
            break;
          case 'update':
            this.$emit('update');
            break;
          case 'delete':
            this.$emit('delete');
            break;
          case 'back':
            this.$emit('back');
            break;
          case 'close':
            this.$emit('close');
            break;
          case 'list':
            this.$emit('list');
            break;
          default:
            console.error('Unknown emit type:', this.emitType);
        }
      }
    }
  };
  </script>
  
  <style scoped>
      
    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background-color: black;
        color: white;
        border: none;
        border-radius: 10px;
        padding: 0.2rem 0.8rem;
        cursor: pointer;
        gap: 0.5rem;
    }
  </style>
  